define('ContactUs.Model', [
    'Backbone',
    'underscore',
    'Utils'
], function ContactUsModel(
    Backbone,
    _,
    Utils
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath('services/ContactUsModule.Service.ss')
        ),
        validation: {
            firstname: {
                required: true,
                msg: _('Name is required').translate()
            },
            orderNumber: {
                required: true,
                msg: _('Please provide valid order number').translate()
            },
            email: {
                required: true,
                pattern: 'email',
                msg: _('Please provide a valid email').translate()
            },
            phone: {
                required: true,
                fn: _.validatePhone,
                msg: _('Please provide a valid phone').translate()
            },
            updateOrder: {
                required: true,
                msg: _('Update order is required').translate()
            },
            incomingmessage: {
                required: true,
                msg: _('A message is required').translate()
            }
        }
    });
});
